import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'login',
    component:  () => import('@/views/login'),
    meta: { requiresAuth: false } // 不需要认证
  },
  {
    path: '/login',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const isLoggedIn = store.getters['user/isLoggedIn']
  
  // 检查路由是否需要认证
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isLoggedIn) {
      // 未登录，重定向到登录页
      next({
        path: '/login',
        query: { redirect: to.fullPath } // 保存目标路由，登录后可以跳转回来
      })
    } else {
      // 已登录，允许访问
      next()
    }
  } else if (to.path === '/login' && isLoggedIn) {
    // 已登录用户访问登录页，重定向到首页
    next({ path: '/' })
  } else {
    // 不需要认证的路由，直接放行
    next()
  }
})

// 全局后置钩子
router.afterEach((to) => {
  // 可以在这里添加页面访问统计等
  document.title = to.meta.title ? `${to.meta.title} - 云间漫步` : '云间漫步'
})

export default router
